import { useEffect, useState } from 'react';

const useSiteMenuClone = () => {

  
  const [isMenuCloned, setIsMenuCloned] = useState(false);

  useEffect(() => {
    const cloneMenu = () => {
      // Clone the menu when this function is called
      if (!isMenuCloned) {
        const menu = document.querySelector('.js-clone-nav');
        if (menu) {
          const clonedMenu = menu.cloneNode(true);
          clonedMenu.classList.add('site-nav-wrap');
          const menuBody = document.querySelector('.site-mobile-menu-body');
          menuBody.appendChild(clonedMenu);
          setIsMenuCloned(true);
        }
      }
    };

    const removeClonedMenu = () => {
      // Remove the cloned menu when this function is called
      const clonedMenu = document.querySelector('.site-nav-wrap');
      if (clonedMenu) {
        clonedMenu.remove();
      }
    };

    // Add event listeners for menu interactions
    const handleArrowCollapseClick = (e) => {
      const arrow = e.target;
      const closestLi = arrow.closest('li');
      const collapse = closestLi.querySelector('.collapse');
      if (collapse && collapse.classList.contains('show')) {
        arrow.classList.remove('active');
      } else {
        arrow.classList.add('active');
      }
      e.preventDefault();
    };

    const handleMenuToggleClick = (e) => {
      const body = document.querySelector('body');
      
      const menuToggle = e.target;
      if (body.classList.contains('offcanvas-menu')) {
        body.classList.remove('offcanvas-menu');
        menuToggle.classList.remove('active');
      } else {
        body.classList.add('offcanvas-menu');
        menuToggle.classList.add('active');
      }
      e.preventDefault();
    };

    const handleOutsideClick = (e) => {
      const container = document.querySelector('.site-mobile-menu');
      if (!container.contains(e.target)) {
        const body = document.querySelector('body');
        if (body.classList.contains('offcanvas-menu')) {
          body.classList.remove('offcanvas-menu');
          const menuToggle = document.querySelector('.js-menu-toggle');
          if (menuToggle) {
            menuToggle.classList.remove('active');
          }
        }
      }
    };

    document.querySelectorAll('.arrow-collapse').forEach((arrow) => {
      arrow.addEventListener('click', handleArrowCollapseClick);
    });

    document.querySelectorAll('.js-menu-toggle').forEach((menuToggle) => {
      menuToggle.addEventListener('click', handleMenuToggleClick);
    });

    document.addEventListener('mouseup', handleOutsideClick);

    // Clean up the event listeners when the component unmounts
    return () => {
      document.querySelectorAll('.arrow-collapse').forEach((arrow) => {
        arrow.removeEventListener('click', handleArrowCollapseClick);
      });

      document.querySelectorAll('.js-menu-toggle').forEach((menuToggle) => {
        menuToggle.removeEventListener('click', handleMenuToggleClick);
      });

      document.removeEventListener('mouseup', handleOutsideClick);

      // Remove the cloned menu when the component unmounts
      removeClonedMenu();
    };
  }, [isMenuCloned]);

  return { cloneMenu: isMenuCloned, setIsMenuCloned };
};

export default useSiteMenuClone;
